import { $http } from '@/plugins/axios';
import { AxiosResponse } from 'axios';

export const featurePopupService = {
	list: (): Promise<AxiosResponse> => {
		return $http.get('v1/staff/feature_popups', {
			params: { platform: 'web' },
		});
	},
	snooze: (id: number | string): Promise<AxiosResponse> => {
		return $http.post(`v1/staff/feature_popups/${id}/snooze`);
	},
};
